import { render, staticRenderFns } from "./checkhotelGroup.vue?vue&type=template&id=bf13d4a8&scoped=true"
import script from "./checkhotelGroup.vue?vue&type=script&lang=js"
export * from "./checkhotelGroup.vue?vue&type=script&lang=js"
import style0 from "./checkhotelGroup.vue?vue&type=style&index=0&id=bf13d4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf13d4a8",
  null
  
)

export default component.exports